import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { ShareStoreListingPageProps } from './components/ShareStoreListingPageContentWrapper';

const ShareStoreListingPageContentWrapper = lazy(
  () => import('./components/ShareStoreListingPageContentWrapper'),
);

export const ShareStoreListingPage = wrapLazyNavigatorScreen(
  (props: ShareStoreListingPageProps) => {
    return <ShareStoreListingPageContentWrapper {...props} />;
  },
  {
    headerShown: false,
  },
);
